export default __webpack_public_path__ + "static/tractor3-e4d2abf39e53de6558262611ccc963ca.jpg";